module.exports = __webpack_public_path__ + "img/1024.0d5a8c24.svg";